import { useState } from "react";
import { FontService } from "../../shared/services/font/FontService";

const UseFontUploader = () => {
    const [uploadSuccess, setUploadSuccess] = useState<boolean | null>(null);

    const uploadFont = async (fontFile: File) => {
        console.log(`Uploading ${fontFile.name}`);
        const service = new FontService();
        const font = await service.uploadFont(fontFile);
    console.log(font);
        setUploadSuccess(true);
        setTimeout(() => setUploadSuccess(null), 3000);
    }

    return {
        uploadFont,
        uploadSuccess
    };

};


export default UseFontUploader;
